import { gql } from "@apollo/client";

export const CREATE_ACADEMIC_YEAR = gql`
  mutation CreateAcademicYear($input: AcademicYearCreateInput) {
    createAcademicYear(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_ACADEMIC_YEAR_PAGINATION = gql`
  query GetAcademicYearPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $keyword: String
  ) {
    getAcademicYearPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      keyword: $keyword
    ) {
      data {
        start_date
        remark
        is_active
        end_date
        academic_year
        _id
        quarter_1 {
          start_date
          end_date
        }
        quarter_2 {
          start_date
          end_date
        }
        quarter_3 {
          start_date
          end_date
        }
        quarter_4 {
          start_date
          end_date
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_ACADEMIC_YEAR = gql`
  mutation UpdateAcademicYear($id: ID!, $input: AcademicYearCreateInput) {
    updateAcademicYear(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DELETE_ACADEMIC_YEAR = gql`
  mutation DeleteAcademicYear($id: ID!) {
    deleteAcademicYear(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const UPDATE_ACADEMIC_YEAR_STATUS = gql`
mutation UpdateAcademicYearStatus($id: ID) {
  updateAcademicYearStatus(_id: $id) {
    message {
      message_en
      message_kh
    }
    is_success
  }
}`

export const GET_ACTIVE_ACADEMIC_YEAR = gql`
  query GetActiveAcademicYear {
    getActiveAcademicYear {
      _id
      academic_year
    }
}`
